<script>
export default {
  name: "MkSalads",
  data() {
    return {
      salads: [
        {
          name: "Витаминска салата",
          text: "Марула, зелка, морков, дресинг",
          price: "90 ден.",
        },
        {
          name: "Цезар салата",
          text: "Марула, пилешки стек, кубети, домат шери, пармезан, дресинг, пченка",
          price: "170 ден.",
        },
        {
          name: "Туна салата",
          text: "Марула, туна, кромид, домат шери, пченка, дресинг",
          price: "220 ден.",
        },
      ],
    };
  },
}
</script>

<template>
<div class="main">
  <base-card v-for="salad in salads" :key="salad.name">
    <v-card-title>{{ salad.name }}</v-card-title>
    <v-card-text>{{ salad.text }}</v-card-text>
    <v-card-actions class="flex text-right"
    ><v-spacer></v-spacer>{{ salad.price }}</v-card-actions
    >
  </base-card>
</div>
</template>

<style scoped>
.main {
  min-height: 100vh;
  background: transparent;
}
</style>